type DateType = Date | string;

export const getDatePortion = (date: DateType) => {
  const dateString = new Date(date).toISOString();

  return dateString.slice(0, dateString.indexOf('T'));
};

export const isAfter = (comparisonDate: DateType, baseDate: DateType) => {
  const baseDateString = getDatePortion(baseDate);
  const compDateString = getDatePortion(comparisonDate);

  return compDateString > baseDateString;
};

export const isBefore = (comparisonDate: DateType, baseDate: DateType) => {
  const baseDateString = getDatePortion(baseDate);
  const compDateString = getDatePortion(comparisonDate);

  return compDateString < baseDateString;
};

export const isSame = (d1: DateType, d2: DateType) => {
  const date1String = getDatePortion(d1);
  const date2String = getDatePortion(d2);

  return date1String === date2String;
};

export const isSameOrBefore = (comparisonDate: DateType, baseDate: DateType) =>
  isSame(comparisonDate, baseDate) || isBefore(comparisonDate, baseDate);

export const isSameOrAfter = (comparisonDate: DateType, baseDate: DateType) =>
  isSame(comparisonDate, baseDate) || isAfter(comparisonDate, baseDate);

export const getWithAddedDays = (baseDate: DateType, days: number) => {
  const date = new Date(baseDate);
  date.setDate(date.getDate() + days);

  return date;
};

export const getWithSubtractedDays = (baseDate: DateType, days: number) => {
  const date = new Date(baseDate);
  date.setDate(date.getDate() - days);

  return date;
};

export const getCalendarDaysUntilDate = (futureDate: DateType, fromDate: DateType = new Date()) => {
  const from = new Date(getDatePortion(fromDate));
  const to = new Date(getDatePortion(futureDate));
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const millisBetween = to.getTime() - from.getTime();

  return Math.ceil(millisBetween / millisecondsPerDay);
};

export const getTimeNHoursBefore = (dateStr: string, hours: number) => {
  return new Date(dateStr).getTime() - hours * 60 * 60 * 1000;
};
